<template>
  <div class="FootContent">
    <div class="bg">
      <div class="flex font-color">
        <div class="flex-start">
          <div>
            <span>联系我们</span> &nbsp;Contact us
          </div>
          <div>地址：&nbsp;Workshop C5, 15/F, TML Tower, No. 3 Hoi Shing Road, Tsuen Wan, N.T., Hong Kong</div>
          <div>邮箱：&nbsp;service@gepholding.com</div>
        </div>
        <div>
          <img class="map" src="../assets/images/foot_map.png">
        </div>
      </div>
      <div class="copyright">Copyright © www.GEPholding.com, All Rights Reserved.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FootContent",

  computed: {},
  methods: {}
};
</script>

<style lang="scss">
.FootContent {
  .bg {
    width: 100%;
    height: 480px;
     background: url(../assets/images/footer_bg.jpg) no-repeat;
     background-size: 100% 100%;
    text-align: center;
  }
  .flex {
    display: flex;
    justify-content: center;
    padding: 40px 0 70px 0;
    .map {
      width: 513px;
      height: 260px;
      margin-left: 114px;
      margin-top: 40px;
    }
    .flex-start {
      margin: 40px 99px 0 0;
      text-align: left;
      div:first-child {
        padding: 0 0 35px 0;
        span {
          width: 76px;
          height: 25px;
          font-size: 18px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 25px;
        }
      }
      div {
        font-family: PingFangSC-Thin, sans-serif;
        font-size: 16px;
        font-weight: normal;
        color: rgba(255,255,255,0.79);
      }
    }
    .flex-end {
      margin: 114px 0 0 0;
      text-align: left;
      div:last-child {
        padding: 12px 0 0 0;
      }
      div {
        padding: 0 0 10px 0;
        display: flex;
        align-items: center;
      }
      .follow {
        img:first-child {
          padding-left: 20px;
        }
        img {
          width: 21px;
          height: 17px;
          padding: 0 7px;
        }
      }
    }
  }
  .font-color {
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 40px;
  }
  .copyright {
    font-size: 14px;
    font-family: PingFangSC-Thin, sans-serif;
    color: rgba(255, 255, 255, 0.6);
    line-height: 17px;
    letter-spacing: 1px;
  }
}
</style>
